import React from "react";
import { OtherPermissionsSectionProps } from "../types/types";
import { Form } from "@components";
import { REGIONS } from "../constants/constants";

export const OtherPermissionsSection: React.FC<OtherPermissionsSectionProps> = ({
  sectionNumber,
  form,
  onFormValueChange,
  region,
}) => {
  return (
    <>
      <Form.Title>{`${sectionNumber} - Other Permissions/Acceses`}</Form.Title>
      {region !== REGIONS.CSP && region !== REGIONS.CSP_LATAM ? (
        <>
          <Form.Checkbox
            label={
              region === REGIONS.MARKETING
                ? "Marketing User"
                : "Steelbrick / Salesforce CPQ"
            }
            name="permission1"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission1}
          />
          <Form.Checkbox
            label={
              region === REGIONS.MARKETING
                ? "No CRM User License"
                : "SE CSP Permission Set"
            }
            name="permission2"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission2}
          />
        </>
      ) : null}
      {region === REGIONS.UK || region === REGIONS.UK_ENTERPRISE ? (
        <>
          <Form.Checkbox
            label="Opportunity - Merchant ID Read/Write Access"
            name="permission3"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission3}
          />
          <Form.Checkbox
            label="Contest Participant Salesforce"
            name="permission4"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission4}
          />
          <Form.Checkbox
            label="Scorecard Manager"
            name="permission5"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission5}
          />
          <Form.Checkbox
            label="SCB Administrator Salesforce"
            name="permission6"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission6}
          />
        </>
      ) : null}
      {region !== REGIONS.CSP &&
      region !== REGIONS.CSP_LATAM &&
      region !== REGIONS.MARKETING ? (
        <Form.Checkbox
          label="Docusign"
          name="permission7"
          onChange={onFormValueChange}
          size={4}
          value={form.values.permission7}
        />
      ) : null}
      {region !== REGIONS.MARKETING ? (
        <Form.Checkbox
          label="Knowledge Users"
          name="permission8"
          onChange={onFormValueChange}
          size={4}
          value={form.values.permission8}
        />
      ) : null}
      {region === REGIONS.UK || region === REGIONS.UK_ENTERPRISE ? (
        <>
          <Form.Checkbox
            label="Scorecard Admin"
            name="permission9"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission9}
          />
          <Form.Checkbox
            label="Scorecard User"
            name="permission10"
            onChange={onFormValueChange}
            size={4}
            value={form.values.permission10}
          />
        </>
      ) : null}
    </>
  );
};
